import { fetchSCS } from '@cube/utils/lib/scs-api';

export function loadData(startContentServiceOrigin, site, feed) {
	return fetchSCS(`/alerts/id/${feed}/`, site, startContentServiceOrigin);
}
